import React, { useEffect } from 'react'
import './Main.css'
import Categories from '../categories/Categories'
import Page from '../layouts/Page'
import BlogPart from '../blog/BlogPart'
import AboutPart from '../about/AboutPart'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import { Navigate } from 'react-router-dom'
import { getOrdersUser } from '../../redux/actions/orderActions'
import { RootState, useAppDispatch, useAppSelector } from '../../store'
function Main() {
  const dispatch = useAppDispatch()
  const user = useAppSelector((state: RootState) => state.user)
  console.log(user)
  // GET ALL PRODUCT
  // GET ALL CATEGORIES WHEN LOGIN TO SHOW
  useEffect(() => {
    dispatch(getOrdersUser())
  }, [ dispatch ])

  // CHECK USER LOGGON AND REDIRECT TO LOGIN PAGE IF NOT LOGIN
  // const token = localStorage.getItem('token');

  return user.user?.role === 0 ? (
    <div className="main">
      <Header />
      <Page />
      <section className="introduce">
        <div className="img-transform"></div>
        <h1>best banner for you</h1>
      </section>
      <Categories />
      <h1
        style={{ fontSize: '40px', textAlign: 'center', marginBottom: '20px' }}
      >
        What`s news today ?
      </h1>

      <BlogPart />
      <AboutPart />
      <Footer />
    </div>
  ) : (
    <Navigate to="/admin" />
  )
}

export default Main
